import { useEffect, useState } from 'react';

export const SERIES_COLORS = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
  'var(--chart-6)',
  'var(--chart-7)',
  'var(--chart-8)',
];

export const seriesColor = (index) => SERIES_COLORS[index % SERIES_COLORS.length];

const DEMAND_TYPE_COLORS = {
  SUPPORT: 'var(--chart-1)',
  IMPROVEMENT: 'var(--chart-2)',
  PROJECT: 'var(--chart-3)',
  OTHER: 'var(--chart-8)',
};

export const demandTypeColor = (key, index = 0) =>
  DEMAND_TYPE_COLORS[String(key).toUpperCase()] ?? seriesColor(index + 3);

export const AXIS_TICK = { fill: 'var(--color-text-muted)', fontSize: 12 };
export const AXIS_TICK_SM = { fill: 'var(--color-text-muted)', fontSize: 11 };

export const axisProps = {
  axisLine: false,
  tickLine: false,
  tick: AXIS_TICK,
};

export const gridProps = {
  stroke: 'var(--chart-grid)',
  strokeDasharray: '0',
};

export const ANIMATION = { animationDuration: 550, animationEasing: 'ease-out' };

export const toCount = (value) => {
  const num = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(num) ? num : 0;
};

export const formatNumber = (value) => toCount(value).toLocaleString('pt-BR');

export const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};

export const MOBILE_MQ = '(max-width: 768px)';

export const useChartAnimation = () => !useMediaQuery('(prefers-reduced-motion: reduce)');
